export class ExperienceEmbedComponent {
  container = document.querySelector('.passwordless-experience__video');

  constructor() {
    this.initialize();
  }

  initialize() {
    if (!this.container) {
      return;
    }

    const iframe = this.container.querySelector('iframe');
    const dataset = iframe.dataset;

    const urls = dataset.hasOwnProperty('urls') ? dataset.urls.split(',') : [];
    if (!urls.length) {
      return;
    }

    const index = Math.floor(Math.random() * urls.length);

    const queryParams = dataset.hasOwnProperty('queryParams') ? dataset.queryParams : '';

    const url = urls[index] + queryParams;

    iframe.setAttribute('src', url);
  }
}